/** Translucent number chips for dark cards (the boss fight, the wall hero). */
export function StatChips({
  items,
  className = '',
}: {
  items: readonly { label: string; value: number | string | undefined }[]
  className?: string
}) {
  return (
    <dl
      className={`grid gap-2 text-center ${className}`}
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
    >
      {items.map((s) => (
        <div key={s.label} className="rounded-xl bg-white/10 px-2 py-1.5">
          <dt className="text-[10px] uppercase tracking-wide text-violet-200">{s.label}</dt>
          <dd className="text-lg font-black tabular-nums">{s.value ?? '–'}</dd>
        </div>
      ))}
    </dl>
  )
}
